export default {
  list: {
    title: 'Words',
    subtitle: 'List',
    add: 'New word',
  },
  create: {
    title: 'Add',
    subtitle: 'Words',
  },
  importPage: {
    title: 'Import',
    subtitle: 'Words',
  },
  importList: {
    title: 'Word import',
    subtitle: 'History',
    add: 'Import words',
    cardTitle: 'Import history',
    searchPlaceholder: 'Search by file...',
  },
  importForm: {
    cardTitle: 'Import file (.txt)',
    actions: 'Actions',
  },
  edit: {
    subtitle: 'Question bank',
    questionsTitle: 'Questions',
    addQuestion: 'New question',
    levelFilter: 'Filter by level',
  },
  table: {
    title: 'Active words',
    searchPlaceholder: 'Search...',
    exportTxt: 'Export as .txt',
    noContent: 'No words have been registered yet.',
    columns: {
      name: 'Name',
      options: 'Options',
    },
  },
  importTable: {
    columns: {
      date: 'Date',
      file: 'File',
      user: 'User',
      totalRead: 'Total read',
      inserted: 'Inserted',
      options: 'Options',
    },
    system: 'System',
    hide: 'Hide',
    viewWords: 'View words',
    newWordsImported: 'new words imported:',
    noContent: 'No import history found.',
  },
  form: {
    word: {
      label: 'Word:',
      placeholder: 'Enter the word',
      invalid: 'This field is required',
    },
  },
  question: {
    columns: {
      question: 'Question',
      level: 'Level',
      options: 'Options',
    },
    empty: 'No questions registered.',
    addFirst: 'Add the first one',
    placeholder: 'Enter the question here...',
  },
  delete: {
    title: 'Confirm word deletion',
    message: 'Are you sure you want to delete this word?',
    questionTitle: 'Delete question',
    questionMessage:
      'Are you sure you want to permanently delete this question from the system?',
  },
  alert: {
    saved: 'Word saved successfully!',
    deleted: 'Word deleted successfully',
    downloadSuccess: 'Download completed successfully!',
    importSuccess: '{inserted} words inserted out of {total}!',
    importError: 'Error importing file.',
    invalidFileFormat: 'The file format must be .txt',
    loadWordError: 'Error loading the word',
    questionDeleted: 'Question deleted!',
    questionDeleteError: 'Error deleting.',
    questionUpdated: 'Question updated!',
    questionCreated: 'Question created!',
    questionSaveError: 'Error saving the question.',
    saveOrCancelBeforeFilter: 'Save or cancel your changes before filtering.',
  },
};
